import React, { Component } from "react";
import Header from "../components/Header/index";
import Footer from "../components/Footer/index";
import RestuarantLocator from "../components/RestuarantLocator/index";
import { Redirect } from "react-router-dom";

class ResturantLocator extends Component<{history:any},{}> {
  componentDidMount() {
    // document.title = "Restuarant Locator - Tortilla";
    document.title = "Restuarant Locator - Kyochon"
  }
  render() {
    // if (!localStorage.mainToken) {
    //   return <Redirect to="/landing" />
    // }
    return (
      <div className="page-wrapper">
        <div id="page-wrap">
          <Header history={this.props.history}/>
          <RestuarantLocator />
          <Footer />
        </div>
        
      </div>
    );
  }
}

export default ResturantLocator;